import { ChangeEvent, FC } from 'react';
import { FormProps } from '../helpers';
import FormControl from '../form-control';
import { Stack } from '@mui/material';
import Icon from '@/components/icon';
import BaseSwitch from '@/components/base-switch';
import Text from '@/components/text';

interface Props extends FormProps {
  checked?: boolean;
  onChange: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  inline?: boolean;
}

const Switch: FC<Props> = ({
  label,
  checked = false,
  onChange,
  error,
  name,
  fullWidth,
  disabled,
  readonly,
  inline = true,
  size = 'medium',
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.checked, event);

  const hasLabel = !!label;
  const flexDirection = inline ? 'row' : 'column';
  const flexAlign = inline ? 'center' : 'flex-start';

  return (
    <FormControl label="" error={error} name={name} fullWidth={fullWidth}>
      <Stack direction={flexDirection} gap={2} alignItems={flexAlign}>
        {hasLabel && <Text size={size}>{label}</Text>}
        <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={0.5}>
          {disabled && <Icon name="lock" size="small" color="grey" />}
          <BaseSwitch
            checked={checked}
            onChange={handleChange}
            disabled={disabled || readonly}
            size={size}
          />
        </Stack>
      </Stack>
    </FormControl>
  );
};

export default Switch;
